import { render } from "./HomeLayoutHeader.vue?vue&type=template&id=4e813748&ts=true"
import script from "./HomeLayoutHeader.vue?vue&type=script&lang=ts"
export * from "./HomeLayoutHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__